import http from 'plugins/axios';

export default {
  getAuditList(data) {
    return http.get({
      url: '/la/admin/user/login/switch',
      data
    });
  },
  RemoveLog(data) {
    return http.get({
      url: '/la/admin/delect/login/switch',
      data
    });
  }
};
